var _path, _path2, _path3, _path4, _path5;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSignDocument = function SvgSignDocument(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.913 11.7721L11.875 17.8125L8.90625 18.4062L9.5 15.4375L15.5412 9.39708C15.6966 9.24142 15.8811 9.11793 16.0843 9.03367C16.2874 8.94941 16.5052 8.90604 16.7251 8.90604C16.9451 8.90604 17.1629 8.94941 17.366 9.03367C17.5692 9.11793 17.7537 9.24142 17.9091 9.39708L17.9162 9.40342C18.2298 9.71797 18.4057 10.1442 18.4051 10.5884C18.4045 11.0326 18.2275 11.4584 17.913 11.7721Z",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.52832 16.0313H1.77832C1.46338 16.0313 1.16133 15.9061 0.938631 15.6834C0.715932 15.4607 0.59082 15.1587 0.59082 14.8438V1.78125C0.59082 1.46631 0.715932 1.16426 0.938631 0.941561C1.16133 0.718861 1.46338 0.59375 1.77832 0.59375H13.6533C13.9683 0.59375 14.2703 0.718861 14.493 0.941561C14.7157 1.16426 14.8408 1.46631 14.8408 1.78125V7.125",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.52832 4.15625H11.2783",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.15332 7.71875H11.2783",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.15332 11.2812H10.0908",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSignDocument, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/SignDocument.025f12ae.svg";
export { ForwardRef as ReactComponent };